import { GridColumn, GridFilter } from 'types/grid';
import { ListType } from 'types/selectbox';
import { ScheduleGridData } from './types';
import { Status } from 'types/status';

const spacecraftList: ListType[] = [
  { value: 1, label: 'AQUA' },
  { value: 2, label: 'SpaceCraft 1' },
  { value: 3, label: 'SpaceCraft 2' },
  { value: 4, label: 'SpaceCraft 3' }
];

const contactList: ListType[] = [
  { value: 1, label: 'SEOUL' },
  { value: 2, label: 'DAEJEON' },
  { value: 3, label: 'DAEGU' },
  { value: 4, label: 'ULSAN' },
  { value: 5, label: 'BUSAN' },
  { value: 6, label: 'GWANGJU' },
  { value: 7, label: 'INCHEON' }
];

export const scheduleGridFilter: GridFilter[] = [
  {
    label: 'Spacecraft',
    key: 'spacecraft',
    placeholder: 'Select Spacecraft',
    type: 'selectbox',
    list: spacecraftList,
    className: 'col-span-1'
  },
  {
    label: 'Contacts (Ground Station)',
    key: 'groundStation',
    placeholder: 'Select Contacts',
    type: 'selectbox',
    list: contactList,
    className: 'col-span-1'
  },
  {
    label: 'Date',
    key: 'date',
    placeholder: '',
    type: 'date',
    className: 'col-span-2'
  }
];

export const scheduleGridColumns: GridColumn[] = [
  { title: 'Spacecraft', key: 'spacecraft', width: 140 },
  { title: 'Ground Station', key: 'groundstation', width: 140 },
  { title: 'satelliteName', key: 'satelliteName', width: 140 },
  { title: 'Start Time', key: 'StartTime', width: 140 },
  { title: 'End Time', key: 'EndTime', width: 140  },
  { title: 'Available time', key: 'AvailableTime', width: 100 },
  { title: 'MaxElevation', key: 'MaxElevation', width: 100},
  { title: 'Availability', key: 'isDisabled', width: 100},
];

export const scheduleGridStatus: Record<string, Status> = {
  true: { title: 'Sold Out', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  false: { title: 'Reservation', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' },
};